import { jsx } from 'react/jsx-runtime';
import { ResourcePreviewSkeleton } from '../../ResourcePreview/ResourcePreviewSkeleton/ResourcePreviewSkeleton.js';
import { VirtualGrid } from '@fabric-app/ui/components/VirtualGrid/VirtualGrid';
import { IntersectionObserverAnchor } from '@fabric-app/ui/components/IntersectionObserver/IntersectionObserver';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import ResourcePreviewEnhanced from '../../ResourcePreview/ResourcePreviewEnhanced.js';
import { RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS } from '@fabric-app/ui/theme/resourcePreviewConstants';

const getItemSizeOnMobile = (containerWidth, itemWidth = RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS.width, itemHeight = RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS.height) => {
  const sidePadding = 0;
  const gap = 16;
  const innerWidth = containerWidth - 2 * sidePadding;
  const itemsFit = Math.max(Math.floor((innerWidth + gap) / (itemWidth + gap)), 2);
  const newWidth = (innerWidth - gap * (itemsFit - 1)) / itemsFit;
  const newHeight = newWidth / itemWidth * itemHeight;
  return {
    columnWidth: newWidth,
    rowHeight: newHeight,
    columnGap: gap,
    rowGap: gap
  };
};
const VirtualResourceGrid = ({ containerWidth = 0, zoomLevel, resources, resourcesTotalCount = 0, selectedResourceIds, scrollYMargin, disableItemPreviewContextMenu, canMultiSelect, colorLabels, disableDrag, onInfiniteTrigger, virtualGridOptions, resourcePreviewProps, onResourceClick, disableLayoutAnimation }) => {
  const { isMobileView } = useResponsive();
  return /* @__PURE__ */ jsx(VirtualGrid, {
    zoomLevel,
    ...isMobileView ? getItemSizeOnMobile(containerWidth) : virtualGridOptionsDesktop,
    itemsCount: resourcesTotalCount || resources.length,
    scrollYMargin,
    containerWidth,
    renderItem: ({ index }) => {
      const resource = resources[index];
      if (resource) {
        return /* @__PURE__ */ jsx(ResourcePreviewEnhanced, {
          viewMode: "Grid",
          resource,
          selected: selectedResourceIds && selectedResourceIds.includes(resource?.id ?? ""),
          disableContextMenu: disableItemPreviewContextMenu,
          canMultiSelect,
          colorLabels,
          isSelectable: true,
          resourcePreviewProps,
          zoomLevel,
          onClick: onResourceClick,
          disableDrag,
          disableLayoutAnimation
        }, resource.id);
      }
      if (index < resourcesTotalCount) {
        return /* @__PURE__ */ jsx(ResourcePreviewSkeleton, {
          viewMode: "Grid",
          children: index % 10 === 0 && onInfiniteTrigger && /* @__PURE__ */ jsx(IntersectionObserverAnchor, {
            onIntersect: onInfiniteTrigger,
            rootMargin: "500px",
            debounceDelay: 200,
            // for some reason on ios this is not triggering with at leat height of 1px
            style: {
              height: 1,
              position: "absolute"
            }
          }, `${resources.length}-${resources[resources.length - 1]?.id}`)
        }, index);
      }
      return null;
    },
    ...virtualGridOptions
  });
};
const virtualGridOptionsDesktop = {
  columnWidth: 260,
  columnGap: 50,
  rowHeight: 360,
  rowGap: 50
};

export { VirtualResourceGrid };
//# sourceMappingURL=VirtualResourceGrid.js.map
